import styled, { css } from "styled-components"

const getColors = (campaign) => campaign && campaign.template && campaign.template.appearence && campaign.template.appearence.colors

const ClassBuilder = styled.div`
  font-style: inherit;
  ${props => {
    const colors = getColors(props.campaign)
    const c = props.campaign || {}
    // Prefer new token structure; fall back to legacy flat campaign fields so
    // the gamification template keeps its colours with older backends.
    const brandDefault = (colors && colors["brand-default"]) || c.color_primary
    const brandHover   = (colors && colors["brand-hover"])   || c.color_secondary
    const brandPressed = (colors && colors["brand-pressed"]) || c.text_color
    const textTertiary = (colors && colors["text-tertiary"]) || c.navbar_text_color

    return props.campaign && css`
    .primary-text {
      color: ${brandDefault}
    }
    .secondary-text {
      color: ${brandHover}
    }

    .navbar-text {
      color: ${textTertiary}
    }

    .text-color {
      color: ${brandPressed}
    }

    .primary-bg {
      background: ${brandDefault}
      fill: ${brandDefault}
    }

    .primary-fill {
      fill: ${brandDefault}
    }
    .secondary-fill {
      fill: ${brandHover}
    }

    .mish-fill {
      fill: ${textTertiary}
    }

    .primary-bg-after {
      &:after {
        background: ${brandDefault}
      }
    }

    .secondary-bg {
      background: ${brandHover}
      fill: ${brandHover}
    }

    .text-bg {
      background: ${brandPressed}
      fill: ${brandPressed}
    }

    .mish-bg {
      background: ${textTertiary}
      fill: ${textTertiary}
    }

    .border-primary {
      border-color: ${brandDefault}
    }
    .border-secondary {
      border-color: ${brandHover}
    }
    .border-mish {
      border-color: ${textTertiary}
    }

    .half-gradient {
      background: linear-gradient(to bottom, ${brandDefault} 20%, #973031 50%, white 50%)
    }
    .campaign-link {
      position:relative;
      color: ${textTertiary};
      &:after {
        transition: background-color 300ms ease-in;
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: transparent;
      }
      &:visited {
        color: ${textTertiary};
      }
      &:hover {
        color: ${brandDefault};
        &:after {
          background: ${brandDefault};
        }
        path, circle, rect {
          stroke: ${brandDefault};
        }
      }
    }
    .campaign-link-icon {
      &:hover {
        path, circle, rect, polyline, line {
          stroke: ${brandDefault};
        }
      }
    }
    .campaign-drop-down-item {
      &:hover {
        & > path, & >  circle, & > rect, & > polyline, & > line {
          stroke: ${brandDefault};
        }
        color: ${brandDefault};
      }
    }
    .active-link {
      position:relative;
      &:visited {
        color: ${brandDefault};
      }
      &:hover {
        color: ${brandDefault};
      }
      &:after {
        content: '';
        position:absolute;
        bottom:0;
        left:0;
        width: 100%;
        height: 2px;
        background: ${brandDefault}
      }
    }

    .active-link-secondary {
      color: ${textTertiary};

      position:relative;
      &:visited {
        color: ${textTertiary};
      }
      &:hover {
        color: ${brandHover};
      }
    }

    .o-custom-select {

      &__menu, __menu-list {
        border-radius: 0px;
        width: calc(100% - 1rem)
      }

      &__control {
        border-color: #8E959B;
        box-shadow: none;
        border-radius: 0px;
        &--is-focused, &--menu-is-open {
          border: 1px solid ${textTertiary};
          &:hover {
            border: 1px solid ${textTertiary};
          }
        }
      }

      &__option {
        width: calc(100% - 10px);
        margin: 0 5px;
        color: #8E959B;
        cursor: pointer;
        background: white;

        &--is-focused  {
          color: ${textTertiary};
          background: #FAFAFA;
        }

        &--is-selected {
          color: ${textTertiary};
          background: #FAFAFA;
        }

        &:active {
          background: ${textTertiary};
          background: ${brandPressed};

        }
      }
    }
    .g-rankings__dots{
      color: white
      .slick-active {
        span {
          color : ${brandHover};
        }
      }
    }
    .level-active{
      g{
        g{
          use{
            fill: ${brandDefault}
          }
        }
      }
    }
    .level-next-level{
      g{
        g{
          use{
            fill: ${brandHover}
          }
        }
      }
    }
    .level-locked{
      g{
        g{
          use{
            fill:gray
          }
        }
      }
    }

  `
  }}
`
export default ClassBuilder
